import MobileSecondaryNavHeader from "./mobile-secondary-nav-header";
import Modal from "molecules/modals/modal";
import ModalCloseButton from "atoms/buttons/modal-close-button";
import React from "react";
import ShareSpacePanelAtom from "utilities/atoms/bookview/share-space-panel-atom";
import { ModalCloseButtonStyle } from "molecules/constants/modal-close-button-style";
import { ModalTypes } from "molecules/constants/modal-types";
import { useAtomValue } from "jotai";
import { useReferencePanel } from "utilities/hooks/reference-panel/use-reference-panel";
import { useBookviewSearchContext } from "utilities/contexts/bookview-tab-panel/bookview-search-provider";
import MobileBookviewSearchHandle from "organisms/panels/bookview-tab-panels/bookview-search/mobile-bookview-search-handle";
import MobileBookviewSearchPanel from "organisms/panels/bookview-tab-panels/bookview-search/mobile-bookview-search-panel";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface MobileSecondaryNavLegacyPublicationsProps {
    isOpen: boolean;
    toggleOpen: () => void;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const CSS_CLASS_NAME = "c-mobile-secondary-nav";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const MobileSecondaryNavLegacyPublications: React.FC<
    MobileSecondaryNavLegacyPublicationsProps
> = (props: MobileSecondaryNavLegacyPublicationsProps) => {
    const { isOpen, toggleOpen } = props;
    const { isSearchCollapsed, setIsSearchCollapsed } =
        useBookviewSearchContext();

    const shareSpacePanel = useAtomValue(ShareSpacePanelAtom);

    const numberOfShareItems = shareSpacePanel.getShareItemsLength();

    const { userReferences } = useReferencePanel();
    const userReferencesCount = userReferences.count();

    const handleToggleSearchPanel = () => setIsSearchCollapsed((prev) => !prev);

    const modalClassName = `${CSS_CLASS_NAME}__modal${isOpen ? " -search-open" : ""}${isSearchCollapsed ? " -collapsed" : ""}`;

    return (
        <>
            <Modal
                type={ModalTypes.Bottom}
                closeButtonStyle={ModalCloseButtonStyle.Hidden}
                label={"Bookview Secondary Navigation Modal"}
                closeDialog={toggleOpen}
                isVisible={isOpen}
                displayOverlay={!isSearchCollapsed}
                bypassScrollLock={isSearchCollapsed}
                cssClassName={modalClassName}>
                <MobileBookviewSearchHandle
                    handleToggle={handleToggleSearchPanel}
                />

                <MobileSecondaryNavHeader
                    numberOfShareItems={numberOfShareItems}
                    userReferencesCount={userReferencesCount}
                    closeModal={() => {
                        toggleOpen();
                        setIsSearchCollapsed(false);
                    }}
                />

                <div
                    className="-collapsible"
                    data-collapsed={isSearchCollapsed}>
                    <MobileBookviewSearchPanel isInLegacyPublicationView>
                        <div
                            className={`${CSS_CLASS_NAME}__close-button-search`}>
                            <ModalCloseButton
                                modalType={ModalTypes.Bottom}
                                onClick={toggleOpen}
                            />
                        </div>
                    </MobileBookviewSearchPanel>
                </div>
            </Modal>
        </>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default MobileSecondaryNavLegacyPublications;

// #endregion Exports
